import { notification } from 'antd';

const displayNotification = (message, type = 'info', description = '', icon = null) => (message ? notification[type]({
  message,
  description,
  icon,
}) : null);

export default displayNotification;
